export const normativasArgentina = [
  {
    nombre:
      "Resolución 1480-MS/2011 “Guía para Investigaciones con Seres Humanos” a la que la Provincia de Jujuy adhiere según Resolución N° 11039-S-2013.",
    enlace:
      "https://drive.google.com/file/d/1kXkTtLqNvETXAupSFtP_jVEVvrNL0L_Z/view?usp=sharing",
  },
  {
    nombre:
      "Disposición ANMAT 6677/2010 Régimen de Buena Práctica Clínica para Estudios de Farmacología Clínica a las que la Provincia de Jujuy adhiere por Resolución N° 11039-S-2013.",
    enlace:
      "https://drive.google.com/file/d/1n28tCquQlzDrpeaIR83eI5vN6rylz_Rt/view?usp=sharing",
  },
  {
    nombre: "Ley Nacional N° 25.326 de Protección de datos personales",
    enlace:
      "https://drive.google.com/file/d/1YX9vD3N--RVcfMzbenNAoKfJqqwvTotX/view?usp=sharing",
  },
  {
    nombre:
      "Artículos 58 y 59 del Código Civil y Comercial, sobre investigaciones en seres humanos.",
    enlace:
      "https://drive.google.com/file/d/1sO0Z1GBVDgob9_PkZG05R1OTEiMzAM86/view?usp=sharing",
  },
  {
    nombre:
      "Resolución 255/2022 de la Agencia de Acceso a la Información Pública respecto a datos genéticos.",
    enlace:
      "https://drive.google.com/file/d/1e7FIQ9h0WJ3lMQDluruxVzDthzYSkx2i/view?usp=sharing",
  },
  {
    nombre:
      "Resolución 2940-MS/2020 “Guía para biobancos de muestras biológicas de origen humano con fines de investigación” a la que la Provincia de Jujuy adhiere según Resolución N° 446-S-2023.",
    enlace:
      "https://drive.google.com/file/d/1nop4qIOFcdztp62EOXVGtksDs8CutA0B/view?usp=sharing",
  },
];

export const normativasInternacionales = [
  {
    nombre:
      "Pautas éticas internacionales para la investigación relacionada con la salud con seres humanos de la Organización Panamericana de la Salud y Consejo de Organizaciones Internacionales de las Ciencias Médicas (OPS/CIOMS 2016) a las que la Provincia de Jujuy adhiere por Resolución N° 985-S-2023.",
    enlace:
      "https://drive.google.com/file/d/13LF7PGwLarVcm6CzhmZaJSTfHDFDtTqH/view?usp=sharing",
  },
  {
    nombre:
      "Declaración de Helsinki de la Asociación Médica Mundial (AMM) 'Principios éticos para las investigaciones médicas en seres humanos', última revisión (2012-2013)",
    enlace:
      "https://drive.google.com/file/d/1j1VMql3C9_qo4Xcr-_Ut9ZayfXg_GsPZ/view?usp=sharing",
  },
  {
    nombre:
      "Declaración Universal sobre Bioética y Derechos Humanos de la Organización de las Naciones Unidas para la Educación, la Ciencia y la Cultura (UNESCO, 2006)",
    enlace:
      "https://drive.google.com/file/d/1YNaIep4AaZJfOXeFhDf_JkwALZmj94Ok/view?usp=sharing",
  },
  {
    nombre:
      "Declaración Universal sobre el Genoma Humano y los Derechos Humanos (UNESCO, 1997) y Declaración Internacional sobre los datos genéticos humanos (UNESCO, 2003)",
    enlace:
      "https://drive.google.com/file/d/18-yvhNB-kbyTv78QwjLvxf5abtM4FrMF/view?usp=sharing",
  },
];
